import RestClient from './RestClient';
import { Group } from '../../models';
import Classrooms from './Classrooms';

class Groups extends RestClient {
    constructor() {
        super({
            "model": Group,
            "entryPoint": "group",
            "resource": "group",
            "resources": "groups",
            "sortBy": "min_age",
        });

        this.ROLL_CALL_PDF_PATH = '/roll_call_pdf/id';
    }

    removeStudent(group, student) {
        let url = `/group/remove_student/id/${group.id}/student_id/${student.id}`;
        return this.POST(url)
            .then(response => response.json())
            .then(json => {
                if (json.group)
                    return {
                        ...json,
                        group: new Group(json.group)
                    };
                throw new Error(json.flash?.error?.msg || '');
            });
    }

    removeClassroom(group, classroom) {
        return Classrooms.delete(classroom.id)
            .then(json => {
                return this.get(group.id);
            });
    }

    downloadRollCallPdf(group) {
        return this.GET(`/${this.entryPoint}${this.ROLL_CALL_PDF_PATH}/${group.id}`)
            .then(res => res.blob())
            .then(blob => {
                return { file: blob };
            });
    }
}
const GroupsApi = new Groups();

export default GroupsApi;
